import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import ViewListIcon from '@mui/icons-material/ViewList';
import type { ResolverFn } from '../types/breadcrumbTypes';

export const BREADCRUMB_ICONS = {
  home: HomeIcon,
  users: PeopleIcon,
  analytics: AutoGraphIcon,
  logs: ViewListIcon,
} as const;

export const BREADCRUMB_RESOLVERS: Record<string, ResolverFn> = {
  building: ({ params }) => params.building || 'building',
  core: ({ searchParams }) => searchParams.get('site')?.toString() || 'core',
  distro: ({ searchParams }) => searchParams.get('site')?.trim() || 'distro',
  switch: ({ searchParams }) => searchParams.get('site')?.trim() || 'access switch',
};
